import React from 'react';


function PartialSite1(props) {


  return (
    <>
      <div class="firstpage__header">
        <div class="container">
          <div class="header__firstImage">
            <img src="./../img/header__firstImage.png" alt="بکگراند" />
          </div>
          <div class="header_main">
            <h1 class="header_main--title" ref={element => {
              if (element) element.style.setProperty('font-size', '60px', 'important');
            }} style={{ fontFamily: 'aviny-bitkala' }}>مشاوره طراحی و تولید نرم افزار</h1>
            <p class="header_main--description">با بیش از ۱۰ سال سابقه مشاوره طراحی و تولید و نظارت در زمینه نرم افزار های بانکی ، حسابداری ، مالی ، پزشکی و اتوماسون اداری و فروشگاه اینترنتی برآنیم که همه تجربیات و دانش خود را برای تولید و طراحی نرم افزار های جدید برای سازمانها و شرکتها به کار ببریم تا بتوانیم آنها را به بهترین وجه و حرفه ای ترین حالت یاری کنیم.</p>
          </div>
          <div class="header_codeLineImage">
            <img src={require('./../img/mydeveloper.svg')} alt="کد" />
          </div>
        </div>
      </div>

    </>
  )
}

export default PartialSite1;